import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import { toggleLegend } from "@/js/animation.js";
import { defaultPagingChoices, listWineTypes, bottlings } from "@/js/lists.ts";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import RatingComponent from "@/components/rating/RatingComponent.vue";
export default {
  name: "CellarList",
  data: function data() {
    return {
      baseModel: {
        cellarWines: [],
        numberOfCellarWines: 0,
        numberOfPages: 0
      },
      datatable_headers: [{
        text: "",
        value: "image",
        align: "center"
      }, {
        text: "Producer",
        value: "winery",
        align: "center"
      }, {
        text: "Region",
        value: "region",
        align: "center"
      }, {
        text: "Appellation",
        value: "appellation",
        align: "center"
      }, {
        text: "Vintage",
        value: "vintage",
        align: "center"
      }, {
        text: "Bottling",
        value: "bottling",
        align: "center"
      }, {
        text: "Type",
        value: "type",
        align: "center"
      }, {
        text: "Qty",
        value: "qty",
        align: "center",
        sortable: false,
        width: "7.5rem"
      }, {
        text: "Potential",
        value: "cellar_potential",
        align: "center",
        sortable: false,
        width: "2.5rem"
      }, {
        text: "Rating",
        value: "id_wine",
        align: "center",
        sortable: false,
        cellClass: "cursor--default"
      }],
      datatable_items: [],
      pagingLimitsChoices: defaultPagingChoices,
      loadingSearch: false,
      imagesBroken: []
    };
  },
  components: {
    index: indexComponent,
    paging: pagingComponent,
    rating: RatingComponent
  },
  props: {
    searchCriterias: {
      paging: {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      },
      label: {
        default: ""
      }
    },
    loggedUserData: Object
  },
  computed: {
    hasResult: function hasResult() {
      return !this.loadingSearch && this.baseModel.numberOfCellarWines > 0;
    }
  },
  created: function created() {
    if (typeof this.$route.params != "undefined" && typeof this.$route.params.searchCriterias != "undefined") {
      this.searchCriterias = {
        name: this.$route.params.searchCriterias.name,
        paging: this.$route.params.searchCriterias.paging,
        label: this.$route.params.searchCriterias.label
      };
    }
  },
  mounted: function mounted() {
    this.search();
  },
  methods: {
    search: function search() {
      this.$EventBus.$emit("loading", true);
      var instance = this;
      instance.loadingSearch = true;
      request("/v1/cellar/wines", "post", instance.searchCriterias, true, "api").then(function (response) {
        // we dynamically set the size of the array so the reactive side can still be engaged
        instance.baseModel.cellarWines.splice(instance.searchCriterias.paging.limits);

        //Reset datatable datas
        instance.datatable_items = [];

        //Creating datatable datas
        response.data.cellar_wines.forEach(function (cw) {
          instance.datatable_items.push({
            id_cellar_wine: cw.id_cellar_wine,
            image: cw.wine.image,
            imageThumbnail: cw.wine.imageThumbnail,
            type: listWineTypes.find(function (x) {
              return x.id === cw.wine.type;
            }).name,
            region: cw.wine.region.name,
            winery: cw.wine.producer.name,
            appellation: cw.wine.appellation,
            vintage: cw.wine.year,
            qty: cw.quantity,
            cellar_potential: cw.cellar_potential,
            cellar_wine: cw,
            id_wine: cw.wine.id_wine,
            favorite: cw.wine.favorite,
            bottling: bottlings.filter(function (x) {
              return x.value === cw.wine.bottling;
            }).map(function (x) {
              return x.text;
            }).shift()
          });
        });
        instance.baseModel = {
          cellarWines: response.data.cellar_wines,
          numberOfCellarWines: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / instance.searchCriterias.paging.limits)
        };
        instance.searchCriterias.paging.currentPage = instance.searchCriterias.paging.askedPage + 1;
        if (!instance.searchCriterias.paging.currentPage) {
          instance.searchCriterias.paging.currentPage = 0;
        }
        instance.loadingSearch = false;
        instance.$EventBus.$emit("loading", false);
      });
    },
    advancedSearch: function advancedSearch() {
      this.searchCriterias.paging.askedPage = 0;
      this.search();
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.search();
      }
    },
    qtyChanged: function qtyChanged(idCellarWine, newQty) {
      var data = {
        id_cellar_wine: idCellarWine,
        quantity: newQty
      };
      var instance = this;
      instance.$EventBus.$emit("loading", true);
      request("/v1/cellar/wine", "put", data, true, "api").then(function (response) {
        instance.$toasted.show("Qty updated.", {
          type: "success"
        });
        instance.$EventBus.$emit("loading", false);
        instance.search();
      });
    },
    cellarWineDetails: function cellarWineDetails(cellarWineData) {
      this.$router.push({
        name: "userCellarWineDetails",
        params: {
          cellarWine: cellarWineData,
          searchCriterias: this.searchCriterias
        }
      });
    },
    toggleFavorite: function toggleFavorite(idWine, favorite) {
      favorite = !favorite;
      var instance = this;
      // Save the order serverside before saving it in the local storage
      request("/v1/user/favorites/" + idWine + "?isWineToAdd=" + favorite, "put", null, true, "api").then(function (response) {
        if (favorite) {
          instance.$toasted.show("Wine added to your favorites.", {
            type: "success"
          });
        } else {
          instance.$toasted.show("Wine removed from your favorites.", {
            type: "success"
          });
        }
        instance.search();
      });
    },
    rowClicked: function rowClicked(row) {
      this.cellarWineDetails(row.cellar_wine);
    },
    toggleLegend: toggleLegend
  }
};